<template>
<div class="daoh2">
<!--    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="isCollapse">-->
<!--        <router-link v-for="item1 in item" :key="item1.id" :to="item1.path" >-->
<!--            <el-menu-item :index="item1.id">-->
<!--                <span slot="title">{{item1.label}}</span>-->
<!--            </el-menu-item>-->
<!--        </router-link>-->
<!--    </el-menu>-->
    <div class="ti">
       <transition>
        <keep-alive>
            <router-view ></router-view>
        </keep-alive>
       </transition>
    </div>
</div>
</template>
<script>
export default {
  name: 'Jindex',
  data () {
    return {
      isCollapse: false,
      item:[],
      items_list1:[
           {
            id:'7001',
            label: '组织架构',
            icon: 'mdi-home-outline ',
            path:'/Jindex/JAdd',
            pid:7,
          },
          {
            id:'7002',
            label: '架构管理',
            icon: 'mdi-home-outline ',
            path:'/Jindex/JindexAdd',
            pid:7,
          },
          {
            id:'7003',
            label: '部门管理',
            icon: 'mdi-home-outline ',
            path:'/Jindex/JindexAdds',
            pid:7,
          },
          {
            id:'7004',
            label: '人员管理',
            icon: 'mdi-archive-outline ',
            path:'/Jindex/JuserindexAdd',
            pid:7,
          },
          {
            id:'7005',
            label: '架构列表',
            icon: 'mdi-archive-outline ',
            path:'/Jindex/Jlist',
            pid:7,
          },
      ],
    }
  },
  //界面没出来前加载
  created() {
    this.$myhttp.get('admin/lavel2?pid=7',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        if(backdata.data != 1){
          this.item = backdata.data;
        }else{
          this.item = this.items_list1;
        }
        // console.log(backdata.data)
      });
    },
}
</script>
<style scoped>
.daoh2{
    display: flex;
    height: 100%;
}
 .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100px;
    height: 100%;
  }
  a{
      text-decoration: none;
   }
   .ti{
    height: 100%;
    width: 100%;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Jurisdiction/Jindex.vue